/**
 * Minimal Capacitor SplashScreen hide for the native iOS shell.
 *
 * The main iOS shell (v1.5/ios-shell) ships with `launchAutoHide: false`
 * so this JS-side call is the sole signal that drops the splash. The
 * 3000ms `launchShowDuration` in capacitor.config.ts is a backstop for
 * the case where the JS bundle never loads at all.
 *
 * No-op on PWA / web hosts and on any shell build that does not ship
 * the SplashScreen plugin. Returns synchronously after dispatching the
 * hide call; never awaits the bridge round-trip, so a slow
 * SplashScreen.hide() can never delay React mount.
 */

interface CapacitorGlobal {
	Plugins?: {
		SplashScreen?: {
			hide?: (opts?: { fadeOutDuration?: number }) => Promise<void>;
		};
	};
	isNativePlatform?: () => boolean;
}

export function hideNativeSplashScreen(): void {
	const cap = (
		window as unknown as { Capacitor?: CapacitorGlobal }
	).Capacitor;
	if (!cap?.isNativePlatform?.()) return;
	const splash = cap?.Plugins?.SplashScreen;
	if (!splash?.hide) return;
	try {
		const p = splash.hide({ fadeOutDuration: 200 });
		if (p && typeof (p as Promise<void>).catch === 'function') {
			(p as Promise<void>).catch((err) => {
				console.warn('[nativeSplash] hide failed:', err);
			});
		}
	} catch (err) {
		console.warn('[nativeSplash] hide threw:', err);
	}
}
